import { TagCard } from "./TagCard";

interface Tag {
  id: string;
  name: string;
  description: string;
  type: string;
  color: string;
  icon?: string;
  criteria: any;
  created_at: string;
  created_by: string;
  customers: string[];
}

interface TagGridProps {
  tags: Tag[];
  onDelete: (id: string) => void;
}

export const TagGrid = ({ tags, onDelete }: TagGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {tags.map((tag) => (
        <TagCard
          key={tag.id}
          tag={tag}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};